/* Share one background image across two adjacent, explicitly paired sections. */
(function () {
  'use strict';

  if (window.WillieSectionBackgroundPair) {
    window.WillieSectionBackgroundPair.refresh();
    return;
  }

  var START = 'section[data-background-pair="start"]';
  var END = '.pwi[data-background-pair="end"]';
  var LAYER = '[data-paired-background-layer]';
  var PREFIX = '[data-background-pair-prefix]';
  var FLAG = 'data-background-paired';
  var SIZE = '--paired-background-size';
  var POSITION = '--paired-background-position';
  var IMAGE = '--paired-background-image';
  var paints = [];
  var observed = [];
  var pending = false;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(refresh);
  }

  function visible(element) {
    var box = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function imageValue(element) {
    return element.style.backgroundImage || window.getComputedStyle(element).backgroundImage;
  }

  function imageIdentity(value) {
    var match = /^url\(["']?([^"')]+)["']?\)$/.exec(value);
    if (!match) return null;
    try {
      var url = new URL(match[1], document.baseURI);
      // Shopify can serve the same image at different responsive dimensions.
      url.searchParams.delete('width');
      url.searchParams.delete('height');
      return url.href;
    } catch (e) {
      return match[1];
    }
  }

  function adjacentVisibleSection(wrapper, watch, direction) {
    var next = wrapper[direction];
    while (next) {
      if (next.classList.contains('shopify-section')) {
        watch.push(next);
        if (visible(next)) return next;
      }
      next = next[direction];
    }
    return null;
  }

  function findPaint(element) {
    for (var i = 0; i < paints.length; i++) {
      if (paints[i].element === element) return paints[i];
    }
    return null;
  }

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function pixels(value) {
    // Keep subpixel alignment without floating-point noise in CSS values.
    return (Math.round(value * 1000000) / 1000000) + 'px';
  }

  function paint(element, image, size, position, nextPaints) {
    setProperty(element, IMAGE, image);
    setProperty(element, SIZE, size);
    setProperty(element, POSITION, position);
    if (!element.hasAttribute(FLAG)) element.setAttribute(FLAG, '');
    nextPaints.push({ element: element, style: element.getAttribute('style') });
  }

  function reset(element) {
    element.removeAttribute(FLAG);
    element.style.removeProperty(IMAGE);
    element.style.removeProperty(SIZE);
    element.style.removeProperty(POSITION);
  }

  function updateObserved(watch) {
    if (!resizeObserver) return;
    var unique = watch.filter(function (element, index) { return watch.indexOf(element) === index; });
    observed.forEach(function (element) {
      if (unique.indexOf(element) < 0) resizeObserver.unobserve(element);
    });
    unique.forEach(function (element) {
      if (observed.indexOf(element) < 0) resizeObserver.observe(element);
    });
    observed = unique;
  }

  function refresh() {
    pending = false;
    var nextPaints = [];
    var watch = [];
    var starts = document.querySelectorAll(START);

    for (var i = 0; i < starts.length; i++) {
      var start = starts[i];
      var wrapper = start.closest('.shopify-section');
      var layer = start.querySelector(LAYER);
      if (!wrapper || !layer) continue;
      watch.push(wrapper, start, layer);
      if (!visible(wrapper) || !visible(start) || !visible(layer)) continue;

      var next = adjacentVisibleSection(wrapper, watch, 'nextElementSibling');
      var end = next && next.querySelector(END);
      if (!end || !visible(end)) continue;
      watch.push(end);

      var width = Number(start.getAttribute('data-background-width'));
      var height = Number(start.getAttribute('data-background-height'));
      var image = imageValue(layer);
      var identity = imageIdentity(image);
      if (!(width > 0 && height > 0) || !identity || identity !== imageIdentity(imageValue(end))) continue;

      var startBox = layer.getBoundingClientRect();
      var lastBox = end.getBoundingClientRect();
      if (lastBox.top < startBox.top || lastBox.bottom <= startBox.bottom) continue;

      var previous = adjacentVisibleSection(wrapper, watch, 'previousElementSibling');
      var prefix = previous && previous.querySelector(PREFIX);
      if (prefix) watch.push(prefix);
      if (prefix && (!visible(prefix) || identity !== imageIdentity(imageValue(prefix)))) prefix = null;
      var prefixBox = prefix && prefix.getBoundingClientRect();
      if (prefixBox && prefixBox.top >= startBox.top) prefix = null;
      var firstBox = prefix ? prefixBox : startBox;
      var left = Math.min(firstBox.left, startBox.left, lastBox.left);
      var right = Math.max(firstBox.right, startBox.right, lastBox.right);
      var spanHeight = lastBox.bottom - firstBox.top;
      var scale = Math.max((right - left) / width, spanHeight / height);
      var imageWidth = width * scale;
      var imageHeight = height * scale;
      var imageLeft = left + (right - left - imageWidth) / 2;
      var size = pixels(imageWidth) + ' ' + pixels(imageHeight);

      if (prefix) paint(prefix, image, size, pixels(imageLeft - prefixBox.left) + ' 0px', nextPaints);
      paint(layer, image, size, pixels(imageLeft - startBox.left) + ' ' + pixels(firstBox.top - startBox.top), nextPaints);
      paint(end, image, size, pixels(imageLeft - lastBox.left) + ' ' + pixels(firstBox.top - lastBox.top), nextPaints);
    }

    paints.forEach(function (entry) {
      var retained = nextPaints.some(function (next) { return next.element === entry.element; });
      if (!retained) reset(entry.element);
    });
    paints = nextPaints;
    updateObserved(watch);
  }

  function relevantNode(node) {
    return node.nodeType === 1 && (node.matches('.shopify-section, ' + START + ', ' + END + ', ' + LAYER + ', ' + PREFIX) || node.querySelector(START + ', ' + END + ', ' + LAYER + ', ' + PREFIX));
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target;
      if (record.type === 'childList') {
        var nodes = Array.prototype.slice.call(record.addedNodes).concat(Array.prototype.slice.call(record.removedNodes));
        if (nodes.some(relevantNode)) { schedule(); return; }
      } else {
        var entry = findPaint(target);
        // Background variable writes must not create their own animation loop.
        if (record.attributeName === 'style' && entry && entry.style === target.getAttribute('style')) continue;
        if (record.attributeName.indexOf('data-background-') === 0 || record.attributeName === 'data-paired-background-layer' || target === document.documentElement || target.matches('.shopify-section, ' + START + ', ' + END + ', ' + LAYER + ', ' + PREFIX)) {
          schedule();
          return;
        }
      }
    }
  }

  if (window.MutationObserver) {
    new MutationObserver(onMutations).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-active-line', 'data-background-pair', 'data-background-pair-prefix', 'data-background-width', 'data-background-height', 'data-paired-background-layer', 'class', 'style', 'hidden']
    });
  }

  window.addEventListener('resize', schedule);
  document.addEventListener('line:change', schedule);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  document.addEventListener('load', function (event) {
    var element = event.target;
    if (element.closest && element.closest(START + ', ' + END + ', ' + PREFIX)) schedule();
  }, true);
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
  }
  window.WillieSectionBackgroundPair = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
